import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ColorItems from '@features/trend-research/components/details/components/Filters/ColorItems';
import useQueryString from '@features/trend-research/hooks/useQueryString';
import { formatFabricName, sourceType } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findTrendResearchColor } from '@services/trendResearch';

const SolidColor = ({ onSelectionChange }) => {
	const dispatch = useDispatch();
	const location = useLocation();

	const [queryStringForApi, setQueryStringForApi] = useState('');
	const [selectedColors, setSelectedColors] = useState([]);
	const [colors, setColors] = useState([]);

	const queryString = useQueryString();
	const { source } = location?.state || {};

	const handleColorClick = (color) => {
		onSelectionChange(color);
	};

	useEffect(() => {
		const searchParams = new URLSearchParams(queryString);
		if (searchParams.has('colorList')) {
			searchParams.delete('colorList');
		}
		const updatedQueryString = `?${searchParams.toString()}`;
		setQueryStringForApi(updatedQueryString);
	}, [queryString]);

	const fetchDetailsCount = async () => {
		try {
			dispatch(openLoader());
			const response = await findTrendResearchColor(sourceType[source], queryStringForApi);
			setColors(response);

			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchDetailsCount(queryStringForApi);
	}, [queryStringForApi]);

	useEffect(() => {
		if (location?.state && location?.state?.selectedItem) {
			setSelectedColors(formatFabricName(location?.state?.selectedItem?.colorName));
		}
	}, [location.state]);

	return (
		<ColorItems
			selectedColors={selectedColors}
			colors={colors}
			onSelectionChange={handleColorClick}
			multiple
			showAll
		/>
	);
};

export default SolidColor;
